import React, { ReactNode } from 'react';
import "./style.less";

export interface IContent{
	children: ReactNode;
}

export default function Content({
	children = null,
} : IContent) {
	return <div className="content">
		{children}
	</div>;
}
